// Configuration for the SPA
// These values are injected at build time from environment variables

export const config = {
	api: {
		url: import.meta.env.VITE_API_URL || 'http://localhost:8080',
	},
	google: {
		clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
	},
} as const;
